import { Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import { HttpEventType, HttpErrorResponse } from "@angular/common/http";
import { timer } from "rxjs";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { SellerContract } from "../../entity/SellerContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { LoaderService } from "../../service/loader.service";
import { User } from "../../entity/User";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { InfoDialog } from "../incs/info-dialog.component";
import { HeaderComponent } from "../incs/header.component";


@Component({
    selector: "kilowant-seller-bulk-import",
    templateUrl: "../../../html/seller/seller-bulk-import.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class SellerBulkImportComponent extends AbstractSellerComponent {

    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    dataSource2: MatTableDataSource<SellerContract> = new MatTableDataSource<SellerContract>([]);

    @ViewChild("utilitiesTableSort") set matSort(sort: MatSort) {
                                         if (this.dataSource!=null) {
                                            this.dataSource.sort = sort;
                                         }
                                     }         
    @ViewChild("contractsTableSort") set matSort2(sort: MatSort) {
                                         if (this.dataSource2!=null) {
                                            this.dataSource2.sort = sort;
                                         }
                                     }
    dialogRef: MatDialogRef<InfoDialog> = null!;

    user: User = null!;
    showError: boolean = false;
    error: string = "";
    errors: string[] = [];
    sellerContracts: SellerContract[] = [];
    deleteTermsDocument: boolean = false;
    displayedColumns: string[] = ["UtilityName","UtilityID","LoadZoneName","LoadZoneID","RateClassName","RateClassID"];    
    displayedColumns2: string[] = ["ContractName","ContractID"];
    validDate: string = "";
    step: number = 1;
    terms:number[] = [6,12,18,24,36];
    fileToUpload: File = null!;
    utilityData: any[] = [];
    progress: number = 0;
    uploading: boolean = false;

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        private loaderService: LoaderService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService,generalService); }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
       this.reloadUser().then(u=>{
          this.reloadInfo();
       });       
    }

    reloadInfo(): void {
        this.generalService.getSellerContracts()
            .then(cs => {
                this.sellerContracts = cs;
                this.dataSource2.data = this.sellerContracts;
                this.dataSource2.sortingDataAccessor = (item, property) => {
                   switch (property) {
                     case "ContractID": {
                        return item.id;
                     }
                     case "ContractName": {
                        return item.name;
                     }
                     default: {
                         return "";
                     }
                  }
               }
        });
        this.utilityData = [];
        for (var pos_u = 0; pos_u<this.user.utilities.length; pos_u++) {
           for (var pos_rl = 0; pos_rl<Math.max(1, this.user.utilities[pos_u].loadZones.length, this.user.utilities[pos_u].rateClasses.length); pos_rl++) {
               var rec = {
                    "UtilityID": ""+this.user.utilities[pos_u].id,
                    "UtilityName": this.user.utilities[pos_u].name,
                    "LoadZoneID": "",
                    "LoadZoneName": "",
                    "RateClassID": "",
                    "RateClassName": ""
               };
               if (pos_rl<this.user.utilities[pos_u].loadZones.length) {
                  rec["LoadZoneID"]=""+this.user.utilities[pos_u].loadZones[pos_rl].id;
                  rec["LoadZoneName"]=""+this.user.utilities[pos_u].loadZones[pos_rl].name;
               } else {
                   rec["LoadZoneID"] = "" + this.user.utilities[pos_u].loadZones[this.user.utilities[pos_u].loadZones.length-1].id;
                   rec["LoadZoneName"] = this.user.utilities[pos_u].loadZones[this.user.utilities[pos_u].loadZones.length - 1].name;
               }
               if (pos_rl<this.user.utilities[pos_u].rateClasses.length) {
                   rec["RateClassID"]=""+this.user.utilities[pos_u].rateClasses[pos_rl].id;
                   rec["RateClassName"]=""+this.user.utilities[pos_u].rateClasses[pos_rl].name;
               } else {
                   rec["RateClassID"] = "" + this.user.utilities[pos_u].rateClasses[this.user.utilities[pos_u].rateClasses.length-1].id;
                   rec["RateClassName"] = "" + this.user.utilities[pos_u].rateClasses[this.user.utilities[pos_u].rateClasses.length-1].name;
               }
               this.utilityData.push(rec);
           }
        }

        this.dataSource.data = this.utilityData;
        this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case "UtilityID": {
             return item.UtilityID;
          }
          case "UtilityName": {
              return item.UtilityName;
          }
          case "LoadZoneID": {
             return item.LoadZoneID;
          }
          case "LoadZoneName": {
              return item.LoadZoneName;
          }
          case "RateClassID": {
             return item.RateClassID;
          }
          case "RateClassName": {
              return item.RateClassName;
          }
          default: {
               return "";
          }
        }
      }
    }

    sendForm(): void {
       this.errors = [];
       if (this.fileToUpload==null) {
          this.errors.push("fileToUpload");
       }
       if ( this.errors.length>0 ) {
            this.showError = true;
            this.error = "Please enter the data requested above.";            
            return;
       }
       this.uploading = true;
       this.loaderService.setDisabled(true);
       this.generalService.bulkImportProceed(this.fileToUpload)
           .subscribe({
              next: (event) => {
               if (event.type === HttpEventType.UploadProgress)
                  this.progress = Math.round(100 * event.loaded / event.total);
               else if (event.type === HttpEventType.Response) {
                  this.loaderService.setDisabled(false);
                  this.openResultsPopup(event.body);
               }
              },
              error:(err: HttpErrorResponse) => {
                if (err.status == 400) {
                  this.loaderService.setDisabled(false);
                  this.openResultsPopup(err.error);
                }
              }
          });
    }

    resetError(field: string): void {
       if (this.errors.includes(field)) {
           this.errors.splice(this.errors.indexOf(field), 1);
       }
       this.showError = (this.errors.length>0);
    }

    compareFn(c1: EntityBase, c2: EntityBase): boolean {
        return c1 && c2 ? c1.id === c2.id : c1 === c2;
    }

    compareKeyFn(c1: Pair, c2: Pair): boolean {
        return c1 && c2 ? c1.key === c2.key : c1 === c2;
    }

    handleFileInput(event: Event) {
       const target = event.target as HTMLInputElement;
       this.fileToUpload = (target.files as FileList).item(0) as File;
       this.resetError("fileToUpload");
       console.log( this.fileToUpload);
    }

   deleteFile(): void {
       this.fileToUpload = null!;
   }

   cancel(): void {
      this.router.navigate(["/seller/home"]);
   }
   nextStep(){
      this.step++;
   }
   fileUpload(){
      this.step=3;
      timer(500).subscribe((count) => {
         var element = (<HTMLAnchorElement>document.querySelector("#step3"));
         if (element) {
            element.scrollIntoView();
         }
      });
   }
   backStep(){
       this.step--;
   }
   getTemplateFile(name: string): void {
       var a = document.createElement("a");
       document.body.appendChild(a);
       this.generalService.getBulkImportTemplate(name)
       .subscribe((data:any) => {
          var blob = new Blob([data], {type: "octet/stream"});
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
      });
   }

   openResultsPopup(res:any): void {
     this.dialogRef = this.dialog.open(InfoDialog, {
        disableClose: false
        ,panelClass: "card-popup"
     });
     this.dialogRef.componentInstance.infoTitle = "Results";
     this.dialogRef.componentInstance.infoMessage = (res.length>0)?res:"Import has been completed successfully.";
     this.dialogRef.afterClosed().subscribe(result => {          
          this.dialogRef = null!;
          if (res.length==0) {
             this.router.navigate(["seller/home"]);
          } else {
             this.fileToUpload = null!;
             this.progress = 0;
             this.uploading = false;             
          }
      });
   }
}